function Cuba({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_521_1016)">
      <path d="M6.25e-05 2.78265H0V29.2174H6.25e-05V16.0001V2.78265Z" fill="#FF9811"/>
      <path d="M15.9999 31.9999C24.8365 31.9999 31.9999 24.8365 31.9999 16C31.9999 7.16348 24.8365 6.10352e-05 15.9999 6.10352e-05C7.16342 6.10352e-05 0 7.16348 0 16C0 24.8365 7.16342 31.9999 15.9999 31.9999Z" fill="#F0F0F0"/>
      <path d="M16.0001 0.00012207C10.7656 0.00012207 6.11853 2.51406 3.19946 6.40012H28.8008C25.8818 2.514 21.2346 0.00012207 16.0001 0.00012207V0.00012207Z" fill="#0052B4"/>
      <path d="M16.0001 31.9999C21.2346 31.9999 25.8818 29.486 28.8008 25.5999H3.19946C6.11846 29.486 10.7656 31.9999 16.0001 31.9999Z" fill="#0052B4"/>
      <path d="M0.00012207 16C0.00012207 17.096 0.110622 18.1661 0.320559 19.2H31.6797C31.8897 18.1661 32.0001 17.096 32.0001 16C32.0001 14.9041 31.8896 13.834 31.6797 12.8H0.320559C0.110622 13.834 0.00012207 14.9041 0.00012207 16V16Z" fill="#0052B4"/>
      <path d="M4.68636 4.6864C-1.56196 10.9347 -1.56196 21.0654 4.68636 27.3138C7.26842 24.7318 9.75167 22.2485 16 16.0002L4.68636 4.6864Z" fill="#D80027"/>
      <path d="M6.47572 11.8262L7.5116 15.0146H10.8645L8.15216 16.9854L9.18804 20.1739L6.47572 18.2032L3.76329 20.1739L4.79941 16.9854L2.08704 15.0146H5.43966L6.47572 11.8262Z" fill="#F0F0F0"/>
    </g>
  </svg>

  `;

  return baseXml;
}

export default Cuba;
